import React, { useEffect, useState } from "react";
import shallow from "zustand/shallow";
import useCurrentAccountStore from "./AccountStore";
import InputElement from "features/forms/components/InputElement";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers";
import InputWrapper from "features/forms/components/InputWrapper";
import OpenModalButton from "../features/deal/components/OpenModalButton";
import ChildrenModal from "../components/modals/ChildrenModal";
import dayjs from "dayjs";
import AccountInsurancePage from "./AccountInsurancePage";
import Swal from "sweetalert2";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";

const AccountInsurance = () => {
	const today = dayjs().format("YYYY-MM-DD");
	const [editModal, setEditModal] = useState(false);
	const toggleEdit = () => {
		setEditModal(!editModal);
	};
	const { insurance, account } = useCurrentAccountStore(
		(state) => ({
			insurance: state.buyersInsuranceInfo,
			account: state.account,
		}),
		shallow
	);
	const privileges = useUserBhphPrivileges();
	const p = privileges();

	console.log(insurance);

	const schema = yup.object().shape({});

	const methods = useForm({
		reValidateMode: "onBlur",
		resolver: yupResolver(schema),
	});
	useEffect(() => {
		console.log(insurance);
		if (
			(insurance === null || dayjs(insurance?.toDate).isBefore(today)) &&
			account.status === 0
		)
			Swal.fire({
				title: "Alert!",
				text: "Please update the  Insurance Information",
				showCancelButton: false,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#3085d6",
				confirmButtonText: "Continue",
			});
	}, []);
	return (
		<InputWrapper
			formTitle="Insurance Info"
			inputComponents={[
				<InputElement
					{...methods}
					readOnly={true}
					value={insurance?.insCompany}
					name="insuranceCompany"
					label="Company"
					type="text"
					colSize="col-12"
				/>,
				<InputElement
					{...methods}
					readOnly={true}
					value={insurance?.policyNum}
					name="insurancePolicyNum"
					label="Policy Number"
					type="text"
					colSize="col-12"
				/>,
				<InputElement
					{...methods}
					readOnly={true}
					value={insurance?.fromDate}
					name="insuranceStartDate"
					label="Start Date"
					type="date"
					colSize="col-12"
				/>,
				<InputElement
					{...methods}
					readOnly={true}
					value={insurance?.toDate}
					name="insuranceEndDate"
					label="End Date"
					type="date"
					colSize="col-12"
				/>,
				<div className="col-12 d-flex justify-content-center align-items-center">
					<OpenModalButton
						iconClass="nc-icon nc-align-center"
						buttonClass="btn-sm btn-primary"
						onClick={toggleEdit}
						buttonText="Update Insurance"
						disabled={!p.updateInsurance}
						buttonColor={
							dayjs(insurance?.toDate).isBefore(today) && account.status === 0
								? "danger blinking-button"
								: "primary"
						}
					/>
				</div>,
				<ChildrenModal
					modal={editModal}
					toggle={() => toggleEdit()}
					children={<AccountInsurancePage toggle={() => toggleEdit()} />}
				/>,
			]}
		/>
	);
};

export default AccountInsurance;
